import googleGeocode from './api/geocoder';

export type GeocoderResponseType = { latitude: number; longitude: number };

export type GoogleGeocoderType = (
  placeId: string
) => Promise<google.maps.GeocoderResult | undefined>;

export async function findPlaceByPlaceId(placeId: string) {
  const result = await googleGeocode(placeId);
  return result;
}

export async function findLocationByPlaceId(placeId: string, geocode: GoogleGeocoderType = googleGeocode) {
  const result = await geocode(placeId);
  if (result) {
    const location: GeocoderResponseType = {
      latitude: result.geometry.location.lat(),
      longitude: result.geometry.location.lng(),
    };
    return location;
  }

  return undefined;
}

export async function findRegionByPlaceId(placeId: string, geocode: GoogleGeocoderType = googleGeocode) {
  const result = await geocode(placeId);
  if (result) {
    const { geometry } = result;

    if (geometry?.viewport) {
      const ne = geometry.viewport.getNorthEast();
      const sw = geometry.viewport.getSouthWest();
      
      // Center - use viewport center or bounds center as fallback
      const googleCenter = geometry.viewport.getCenter() || geometry.bounds?.getCenter();
      const center = new mapkit.Coordinate(googleCenter.lat(), googleCenter.lng());

      // Span
      const latDelta = Math.abs(ne.lat() - sw.lat());
      const lngDelta = Math.abs(ne.lng() - sw.lng());
      const span = new mapkit.CoordinateSpan(latDelta, lngDelta);

      // Return region (better for states/ZIPs)
      return new mapkit.CoordinateRegion(center, span);
    }
    
    // Fallback: just center with a fixed zoom span
    const loc = geometry.location;
    const center = new mapkit.Coordinate(loc.lat(), loc.lng());
    const span = new mapkit.CoordinateSpan(0.1, 0.1); // tweak for your default zoom
    return new mapkit.CoordinateRegion(center, span);
  }

  return undefined;
}

export async function findLocationBoundaryByPlaceId(placeId: string, geocode: GoogleGeocoderType = googleGeocode) {
  const result = await geocode(placeId);
  if (result) {
    const boundary = {
      type: 'Polygon',
      coordinates: [
        [
          [result?.geometry?.bounds?.getNorthEast()?.lng(), result?.geometry?.bounds?.getNorthEast()?.lat()],
          [result?.geometry?.bounds?.getSouthWest()?.lng(), result?.geometry?.bounds?.getSouthWest()?.lat()],
        ],
      ],
    };
    return JSON.stringify(boundary);
  }

  return undefined;
}
